<template>
    <div id="follow">
        <el-drawer
            :title="detailData.title"
            :visible.sync="detailParam.visible"
            size="520px"
            :close-on-press-escape="false"
            :wrapperClosable="false"
        >
            <div class="drawer-wrapper">
                <div class="drawer-main" v-loading="detailData.loading.main">
                    <el-form :model="detailData" ref="detailData" size="small">
                        <el-form-item
                            label="主题："
                            prop="row.title"
                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                        >
                            <el-select v-model="detailData.row.title">
                                <el-option-group>
                                    <el-option :key="1" label="陌生拜访" :value="1"></el-option>
                                    <el-option
                                        :key="2"
                                        label="问题及解决方案"
                                        :value="2"
                                    ></el-option>
                                    <el-option :key="3" label="报价" :value="3"></el-option>
                                    <el-option :key="4" label="订单" :value="4"></el-option>
                                    <el-option :key="5" label="发货问题" :value="5"></el-option>
                                    <el-option :key="6" label="使用情况" :value="6"></el-option>
                                </el-option-group>
                                <el-option-group>
                                    <el-option :key="8" label="活动通知" :value="8"></el-option>
                                    <el-option :key="9" label="其他" :value="9"></el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="内容："
                            prop="row.communicate_record"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input
                                type="textarea"
                                v-model="detailData.row.communicate_record"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="时间："
                            prop="row.follow_at"
                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                        >
                            <el-date-picker
                                v-model="detailData.row.follow_at"
                                type="datetime"
                                :default-value="new Date()"
                                :value-format="'yyyy-MM-dd HH:mm:ss'"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item
                            label="沟通方式："
                            prop="row.communication_id"
                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                        >
                            <el-select
                                v-model="detailData.row.communication_id"
                                :loading="communicationData.loading"
                            >
                                <el-option
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    v-for="item in communicationData.list"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注：" prop="row.memo">
                            <el-input type="textarea" v-model="detailData.row.memo"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitlDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-drawer>

        <v-VisitForm
            :detailParam="componentParam.visitForm"
            v-if="componentParam.visitForm.visible"
        />
    </div>
</template>

<script>
import { CustomerData } from '@/plugin/Customer'
import VisitForm from '@/components/visit/Form'
export default {
    components: {
        'v-VisitForm': VisitForm
    },
    inject: ['reload'],
    mixins: [CustomerData],
    props: ['detailParam'],
    data() {
        return {
            communicationData: {
                loading: true,
                list: []
            },
            detailData: {
                title: '客户跟进',
                loading: {
                    main: false,
                    submit: false
                },
                list: [],
                row: {
                    title: null,
                    communicate_record: null,
                    follow_at: null,
                    communication_id: null,
                    memo: null
                }
            },
            componentParam: {
                visitForm: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetCommunication()
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        // 沟通方式列表
        GetCommunication() {
            if (!this.communicationData.list.length) {
                this.GetCommunicationData({
                    data: {
                        order: 'ASC',
                        ...this.communicationData.pages
                    }
                }).then(res => {
                    this.communicationData.loading = false
                    this.communicationData.list = res.list
                })
            }
        },
        // 增加跟进记录
        SubmitlDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/customer_follow_add',
                        data: {
                            ...this.detailParam.row,
                            ...this.detailData.row
                        }
                    }).then(res => {
                        this.detailData.loading.submit = false
                        if (res.status) {
                            this.$message.error(res.message || '操作失败')
                        } else {
                            this.$confirm(
                                '是否设置下次跟进提醒任务，有条理的安排工作？',
                                '客户跟进成功！',
                                {
                                    confirmButtonText: '好的，帮我安排',
                                    cancelButtonText: '不需要，记忆力很好',
                                    type: 'warning'
                                }
                            )
                                .then(() => {
                                    this.componentParam.visitForm = {
                                        visible: true,
                                        row: {
                                            ...this.detailParam.row
                                        }
                                    }
                                })
                                .catch(() => {
                                    this.reload()
                                })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/common.less';
</style>
